<template>
	<div class="services py-lg-5">
		<div class="container py-3">
			<div class="row">
				<div class="col-12 col-md-6 mb-4 mb-md-0">
					<h6 class="text-gray">
						Usługi
					</h6>
					<h2 class="mb-4">
						Serwisowe
					</h2>
					<ul>
						<li>
							<h4>Przeglądy</h4>
						</li>
						<li>
							<h4>Obsługa gwarancyjna</h4>
						</li>
						<li>
							<h4>Naprawy</h4>
						</li>
					</ul>
				</div>
				<div class="col-12 col-md-6">
					<h6 class="text-gray">
						Usługi
					</h6>
					<h2 class="mb-4">
						Instalacyjne
					</h2>
					<ul>
						<li>
							<h4>Kotły gazowe</h4>
						</li>
						<li>
							<h4>Pompy ciepła</h4>
						</li>
						<li>
							<h4>Instalacje</h4>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name: 'Services'
	}
</script>
